import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';

export class NavMenu extends Component {
  static displayName = NavMenu.name;

  constructor (props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true
    };
  }

  toggleNavbar () {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  render () {
    return (
      <header>
        <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" light>
         
                    {/* <NavbarBrand tag={Link} to="/">Carways Tracking Portal</NavbarBrand> */}
            <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
            <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
              <ul className="navbar-nav flex-grow">
                <li>
                                <a className="text-dark nav-link" href="https://www.carways.com.au/about-carways/">About</a>
                            </li>
                            <li>
                                <a tag={Link} className="text-dark nav-link" href="https://www.carways.com.au/services/">Services</a>
                            </li>
                <li>
                                <a tag={Link} className="text-dark nav-link" href="https://www.carways.com.au/contact-us/">Contact</a>
                </li>
                
              </ul>
            </Collapse>
          
        </Navbar>
      </header>
    );
  }
}
